import classNames from 'classnames';

import { type QueryState } from 'src/core/api/queryState';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { type AccountingSoftware } from 'src/core/modules/bookkeep/integration/status';
import { type TaxAccount } from 'src/core/modules/bookkeep/settings/accounting';

import { DefaultReverseChargeAccountPullTable } from '../../TaxAccountPullSection/common/CommonReverseChargeAccountPullTable';
import styles from '../TaxAccountPullAndSetSection.module.css';

interface Props {
  taxAccountQueryState: QueryState<TaxAccount[]>;
  integration: AccountingSoftware;
}

export type ModalState =
  | { kind: 'closed' }
  | {
      kind: 'addReverseCharge' | 'confirmDeleteReverseCharge';
      id: string;
      name: string;
      codeDebit: string;
      codeCredit: string;
      inputChanged?: boolean;
    };

export const ChiftReverseChargePullSection = ({
  taxAccountQueryState,
  integration,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <div
      id="reverse-charge-accounts"
      className={classNames(
        styles.reverseChargeSection,
        'w-full max-w-lg self-center',
      )}
    >
      <div className={styles.header}>
        <div className={styles.headerText}>
          <h3 className="IntegrationAccountingPage__section-title heading-l">
            {t('bookkeep.integrations.settings.sectionReverseChargeAccounts')}
          </h3>
          <p className={classNames(styles.headerTextDescription, 'body-m')}>
            {t('bookkeep.integrations.chift.reverseChargeAccountsDescription', {
              integration,
            })}
          </p>
        </div>
      </div>

      <DefaultReverseChargeAccountPullTable
        taxAccountQueryState={taxAccountQueryState}
      />
    </div>
  );
};
